import { Grid, Box } from '@chakra-ui/react'
import { FC, useEffect, useMemo } from 'react'

import useParametrizationRevision from '@hook/parametrization/use-revision'
import useFilters from '@hook/shared/use-filters'
import useLayout from '@hook/shared/use-layout'
import useSessions from '@hook/shared/use-sessions'

import Layout from '@component/Layout'
import LayoutEmpty from '@component/Layout/Empty'
import LayoutFilters from '@component/Layout/Filters'
import LayoutLoader from '@component/Layout/Loader'
import TableGrid from '@component/Layout/TableGrid'
import LayoutTools from '@component/Layout/Tools'
import BarToggle from '@component/Parameterization/Revision/BarToggle'
import SelectedTableBar from '@component/Parameterization/Revision/SelectedTablebar'

const ParametrizationRevision: FC = () => {
  const { menuToggle } = useLayout()

  const { getFilters } = useFilters()
  const {
    loading,
    headers,
    data,
    dataPendentes,
    dataAprovados,
    dataRecusados,
    filename,
    params,
    filters,
    filtersList,
    fetching,
    query,
    tableInteraction,
    actions,
    selecteds,
    tableInteractionApproved,
    tableInteractionRecused,
    getData,
    typeGrid,
    getCenters,
    setFilename,
    setQuery,
    handleUpdateParams
  } = useParametrizationRevision()

  const { hasSessions } = useSessions()

  const height = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 30px)'
          : '100vh'
        : hasSessions
        ? 'calc(100vh - 160px)'
        : 'calc(100vh - 142px)',
    [menuToggle, hasSessions]
  )

  const tableHeight = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 259px)'
          : 'calc(100vh - 227px)'
        : hasSessions
        ? 'calc(100vh - 400px)'
        : 'calc(100vh - 368px)',
    [menuToggle, hasSessions]
  )
  useEffect(() => {
    data?.length === 0 && getData()
    getFilters({})

    getCenters()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout title="Parametrização - Revisão">
      <Grid w="100vw" bg="white" h={height} templateColumns="100vw">
        {filters && (
          <LayoutFilters
            filters={filtersList}
            values={params}
            onChange={handleUpdateParams}
            loading={loading}
            canCancel={fetching}
            onFilter={getData}
          />
        )}
        <Box>
          <LayoutTools
            title={filename}
            filters={filters}
            actions={actions}
            query={query}
            onSearchChange={setQuery}
            onTitleChange={setFilename}
            isDisabled={loading || fetching || data.length === 0}
          />

          <BarToggle />

          {loading ? (
            <LayoutLoader
              title="Recuperando informações..."
              message="Aguarde enquanto buscamos os dados no banco de dados"
            />
          ) : data.length === 0 ? (
            <LayoutEmpty
              title="Nada encontrado!"
              message="Filtre sua busca ao lado para obter informações"
            />
          ) : (
            <Box>
              <SelectedTableBar isButtons={selecteds.length > 0} />

              {typeGrid === 1 ? (
                <TableGrid
                  id="purschase-table"
                  headers={headers}
                  query={query}
                  data={dataPendentes}
                  loading={fetching}
                  itsSortable={true}
                  actions={tableInteraction}
                  entity="parametrization-revision"
                  height={tableHeight}
                  isPaged
                />
              ) : (
                []
              )}
              {typeGrid === 2 ? (
                <TableGrid
                  id="purschase-table"
                  headers={headers}
                  query={query}
                  data={dataAprovados}
                  loading={fetching}
                  itsSortable={true}
                  actions={tableInteractionApproved}
                  entity="parametrization-revision"
                  height={tableHeight}
                  isPaged
                />
              ) : (
                []
              )}
              {typeGrid === 3 ? (
                <TableGrid
                  id="purschase-table"
                  headers={headers}
                  query={query}
                  data={dataRecusados}
                  loading={fetching}
                  itsSortable={true}
                  actions={tableInteractionRecused}
                  entity="parametrization-revision"
                  height={tableHeight}
                  isPaged
                />
              ) : (
                []
              )}
            </Box>
          )}
        </Box>
      </Grid>
    </Layout>
  )
}

export default ParametrizationRevision
